import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES, ROUTESMODIFICAR } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: any[];
  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  // End open close
  ngOnInit() {
    let rfcUsuario: string = localStorage.getItem('idUsuario');
    if (rfcUsuario === 'Tracer') {
      this.sidebarnavItems = ROUTESMODIFICAR.filter(sidebarnavItem => sidebarnavItem);
    } else {
      this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
    }
  }
}
